import { useEffect, useRef, useState } from 'react';

const useResizeObserver = (element: HTMLElement | undefined) => {
	const [entries, setEntries] = useState<ResizeObserverEntry[]>([]);

	const observerRef = useRef<ResizeObserver | null>(null);

	useEffect(() => {
		observerRef.current = new ResizeObserver((observerEntries) => {
			setEntries(observerEntries);
		});

		if (element) observerRef.current.observe(element);

		return () => {
			observerRef.current?.disconnect();
		};
	}, [element]);

	return entries;
};

export { useResizeObserver };
